import { render, staticRenderFns } from "./login-phone-form.vue?vue&type=template&id=82deebba&scoped=true"
import script from "./login-phone-form.vue?vue&type=script&lang=js"
export * from "./login-phone-form.vue?vue&type=script&lang=js"
import style0 from "./login-phone-form.vue?vue&type=style&index=0&id=82deebba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82deebba",
  null
  
)

/* custom blocks */
import block0 from "./login-phone-form.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports